module.exports = __webpack_public_path__ + "static/media/online_courses_Wang_Shi-Yuan.39a26548.jpg";